module.exports = __webpack_public_path__ + "static/img/690x480.1d0ef941.png";